<div class="space-y-4">
  <section class="clp-card">
    <div class="clp-card-body space-y-4">
      <div class="flex items-center justify-between gap-2">
        <h3 class="text-base font-semibold text-slate-100">{{ (edit ? 'courseModule.update.title' : 'courseModule.create.title') | translate }}</h3>
        @if (edit) {
          <span class="rounded-full border border-amber-500/40 bg-amber-500/10 px-2 py-0.5 text-[11px] font-semibold text-amber-300">
            {{ 'general.edit' | translate }}
          </span>
        }
      </div>

      <form class="space-y-4" (ngSubmit)="changeCourseModule(courseModuleForm.value)" [formGroup]="courseModuleForm" novalidate>
        <input type="hidden" formControlName="id">

        <div class="grid grid-cols-1 gap-4 md:grid-cols-12">
          <div class="md:col-span-8">
            <label for="title" class="clp-label">{{ 'courseModule.create.name' | translate }}</label>
            <input type="text" class="clp-input" id="title" formControlName="title" required>
            <div class="min-h-[1.15rem]">
              @if (courseModuleForm.controls['title'].invalid && courseModuleForm.controls['title'].touched) {
                <div class="clp-help">
                  {{ 'courseModule.create.invalidTitle' | translate }}
                </div>
              }
            </div>
          </div>

          <div class="md:col-span-2">
            <label for="order" class="clp-label">{{ 'courseModule.create.order' | translate }}</label>
            <input type="number" class="clp-input" id="order" formControlName="order" min="1" required>
            <div class="min-h-[1.15rem]">
              @if (courseModuleForm.controls['order'].invalid && courseModuleForm.controls['order'].touched) {
                <div class="clp-help">
                  {{ 'courseModule.create.invalidOrder' | translate }}
                </div>
              }
            </div>
          </div>

          <div class="md:col-span-2">
            <label class="clp-label select-none opacity-0">{{ 'general.actions' | translate }}</label>
            <div class="grid grid-cols-2 gap-2">
              <button type="submit" class="clp-btn clp-btn-warning inline-flex h-[42px] w-full items-center justify-center gap-2">
                <i class="fa-solid fa-floppy-disk text-xs"></i>
                <span>{{ 'general.save' | translate }}</span>
              </button>
              <button type="button" class="clp-btn clp-btn-ghost inline-flex h-[42px] w-full items-center justify-center gap-2" (click)="clearForm()">
                <i class="fa-solid fa-rotate-left text-xs"></i>
                <span>{{ 'general.clear' | translate }}</span>
              </button>
            </div>
            <div class="min-h-[1.15rem]"></div>
          </div>
        </div>
      </form>
    </div>
  </section>

  <clp-course-module-list
    (courseModuleEditEvent)="editCourseModule($event)"
    [courseId]="courseId">
  </clp-course-module-list>
</div>
